import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	ButtonComponent,
	CollapseComponent,
	CopyTextComponent,
	DividerComponent,
	EmptyStateComponent,
	IconComponent,
	InfoGroupComponent,
	ItemComponent,
	ListDetailComponent,
	TagComponent,
	TileComponent,
	TooltipComponent,
} from '@tecalisdev/infinity';
import { SafeDatePipe } from '../../../../core/pipes/safe-date.pipe';
import { OPERATION_STATUS } from '../../../../operations/models/operations.models';
import { OperationsHelperService } from '../../../../operations/services/operations-helper.service';
import { PolFailReasonService } from '../../../../operations/services/pol-fail-reason.service';
import { MasterService } from '../../../../shared/services/master.service';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { DeveloperCurlButtonComponent } from '../../../../shared/components/developer-curl-button/developer-curl-button.component';
import { IOperationPolDetail, isAutoPolTry } from '../../../models/processes.models';
import { ProcessHelperService } from '../../../services/process-helper.service';

@Component({
	selector: 'app-operation-detail-pol',
	imports: [
		TranslatePipe,
		SafeDatePipe,
		DecimalPipe,
		CollapseComponent,
		TileComponent,
		EmptyStateComponent,
		ButtonComponent,
		InfoGroupComponent,
		IconComponent,
		TagComponent,
		CopyTextComponent,
		DividerComponent,
		ItemComponent,
		ListDetailComponent,
		TooltipComponent,
		DeveloperCurlButtonComponent,
	],
	templateUrl: './operation-detail-pol.component.html',
})
export class OperationDetailPolComponent {
	@Input() operation?: IOperationPolDetail;
	@Input() processUuid?: string;
	@Input() validation?: string;
	@Input() expanded = false;
	@Input() loading = false;
	@Input() contentReady = true;
	@Output() toggleCollapse = new EventEmitter<boolean>();

	public masterService = inject(MasterService);
	public processHelper = inject(ProcessHelperService);
	public operationsHelper = inject(OperationsHelperService);
	public polFailReasonService = inject(PolFailReasonService);
	private navigationService = inject(NavigationService);

	public OPERATION_STATUS = OPERATION_STATUS;
	public readonly isAutoPolTry = isAutoPolTry;

	public get operationCurlPath(): string {
		return this.processUuid && this.operation?.uuid
			? `/process/${this.processUuid}/operations/${this.operation.uuid}`
			: '';
	}

	public formatSecondsToMinutes(seconds: number): string {
		if (seconds === null || seconds === undefined) {
			return '';
		}
		const total = Math.max(0, Math.trunc(Number(seconds) || 0));
		const minutes = Math.floor(total / 60);
		const remainingSeconds = total % 60;
		return `${minutes}m ${remainingSeconds}s`;
	}

	public goToOperationDetail(operationUuid?: string, event?: Event): void {
		if (!operationUuid) return;
		this.navigationService.navigateTo({ routeSegments: ['operations', 'detail', operationUuid] }, event);
	}
}
